module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "media-upload-panel",
    class: {
      'visible': _vm.visible
    }
  }, [_c('div', {
    staticClass: "panel-header"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('i', {
    staticClass: "el-icon-back",
    on: {
      "click": _vm.handleBack
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("素材上传")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-content"
  }, [_c('div', {
    staticClass: "upload-section"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "section-content"
  }, [_c('div', {
    staticClass: "media-upload-container"
  }, [(_vm.mediaUrl) ? _c('div', {
    staticClass: "image-actions"
  }, [_c('el-tooltip', {
    attrs: {
      "content": "删除后重新上传",
      "placement": "top"
    }
  }, [_c('i', {
    staticClass: "el-icon-delete",
    staticStyle: {
      "color": "#ffffff"
    },
    on: {
      "click": function($event) {
        return _vm.handleDeleteMedia()
      }
    }
  })])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "media-upload"
  }, [_c('el-upload', {
    ref: "upload",
    staticClass: "upload-container",
    attrs: {
      "action": "",
      "auto-upload": false,
      "show-file-list": false,
      "on-change": _vm.handleMediaChange,
      "before-upload": _vm.beforeUpload,
      "limit": 1,
      "multiple": false,
      "accept": "image/*,video/mp4,image/gif,application/photoshop,application/x-photoshop,image/vnd.adobe.photoshop,application/psd,image/psd,audio/mpeg,audio/wav"
    }
  }, [_c('div', {
    staticClass: "upload-area"
  }, [(!_vm.mediaUrl) ? [_c('div', {
    staticClass: "upload-content"
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "content": "场景尺寸：4096*4096，道具尺寸：2048*2048",
      "placement": "top"
    }
  }, [_c('div', {
    staticClass: "upload-text"
  }, [_vm._v("点击上传素材")])]), _vm._v(" "), _c('div', {
    staticClass: "upload-hint"
  }, [_vm._v("支持图片、GIF、MP3、MP4、PSD等格式")])], 1)] : _c('div', {
    staticClass: "preview-container"
  }, [(_vm.uploading) ? _c('div', {
    staticClass: "upload-loading"
  }, [_c('i', {
    staticClass: "el-icon-loading"
  }), _vm._v(" "), _c('span', [_vm._v("上传中...")])]) : [(_vm.mediaType === 'image') ? _c('el-image', {
    staticClass: "preview-image",
    attrs: {
      "src": _vm.mediaUrl,
      "fit": "contain"
    }
  }) : (_vm.mediaType === 'video') ? _c('video', {
    staticClass: "preview-video",
    attrs: {
      "src": _vm.mediaUrl,
      "controls": "",
      "autoplay": "",
      "loop": "",
      "muted": ""
    },
    domProps: {
      "muted": true
    }
  }) : (_vm.mediaType === 'gif') ? _c('el-image', {
    staticClass: "preview-image gif-preview",
    attrs: {
      "src": _vm.mediaUrl,
      "fit": "contain"
    }
  }) : (_vm.mediaType === 'psd') ? _c('div', {
    staticClass: "psd-preview"
  }, [
    [_c('div', {
      staticClass: "psd-icon"
    }, [_c('i', {
      staticClass: "el-icon-document"
    }), _vm._v(" "), _c('span', [_vm._v("PSD")])]), _vm._v(" "), _c('div', {
      staticClass: "psd-filename"
    }, [_vm._v(_vm._s(_vm.mediaName))]), _vm._v(" "), _c('div', {
      staticClass: "psd-hint"
    }, [_vm._v("暂不支持直接预览PSD内容。")])]
  ], 2) : (_vm.mediaType === 'audio') ? _c('div', {
    staticClass: "audio-preview"
  }, [_c('div', {
    staticClass: "audio-icon"
  }, [_c('i', {
    staticClass: "el-icon-headset"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.audioExtension ? _vm.audioExtension.toUpperCase() : ''))])]), _vm._v(" "), _c('div', {
    staticClass: "audio-filename"
  }, [_vm._v(_vm._s(_vm.mediaName))]), _vm._v(" "), _c('audio', {
    staticClass: "audio-player",
    attrs: {
      "controls": "",
      "src": _vm.mediaUrl
    }
  }, [_vm._v("\n                                                您的浏览器不支持音频播放。\n                                            ")])]) : _vm._e()]], 2)], 2)])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-container"
  }, [_c('el-form', {
    ref: "uploadForm",
    attrs: {
      "model": _vm.uploadForm,
      "rules": _vm.rules,
      "label-position": "top"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "素材名称",
      "prop": "fileName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入素材名称",
      "maxlength": 50,
      "show-word-limit": ""
    },
    model: {
      value: (_vm.uploadForm.fileName),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "fileName", $$v)
      },
      expression: "uploadForm.fileName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "素材类型",
      "prop": "resourceType"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择素材类型"
    },
    model: {
      value: (_vm.uploadForm.resourceType),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "resourceType", $$v)
      },
      expression: "uploadForm.resourceType"
    }
  }, _vm._l((_vm.resourceTypeOptions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "保存位置",
      "prop": "folderId"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择文件夹",
      "popper-class": "folder-select-dropdown"
    },
    model: {
      value: (_vm.uploadForm.folderId),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "folderId", $$v)
      },
      expression: "uploadForm.folderId"
    }
  }, _vm._l((_vm.flattenedDirectory), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.pathName,
        "value": item.id
      }
    }, [_c('span', {
      staticClass: "folder-path"
    }, [_vm._v(_vm._s(item.pathName))])])
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.saving,
      "disabled": !_vm.mediaUrl || _vm.uploading
    },
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._v("\n                                保存素材\n                            ")])], 1)], 1)], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-header"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "el-icon-circle-plus"
  }), _vm._v(" "), _c('span', [_vm._v("上传素材")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34c7c779","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Upload/MediaUpload.vue
// module id = 379
// module chunks = 0